import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { referralAttribution } from './referralAttribution';

export default function ReferralTracker() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!new URLSearchParams(location.search).has('ref')) return;
    let mounted = true;
    referralAttribution.capture(location.search).then(() => {
      if (!mounted) return;
      if (referralAttribution.snapshot().notice) return;
      // Avoid carrying referral codes into subsequently copied URLs or referrers.
      const search = new URLSearchParams(location.search);
      search.delete('ref');
      navigate({ pathname: location.pathname, search: search.toString(), hash: location.hash }, { replace: true });
    });
    return () => { mounted = false; };
  }, [location.pathname, location.search, location.hash, navigate]);
  return null;
}
